import React from "react";
import { Button, Space, message } from "antd";

const FavouriteSymbols = ({ favouritePNLList, updateSymbolVisibility }) => {
  const favouriteSymbolsLocalStorageKey = "ModelPerformancePage:FavouriteSymbols：favouriteSymbols";

  // Save the symbols that are currently visible as favourites
  const saveFavouriteSymbols = () => {
    const visibleSymbols = favouritePNLList.filter((pnl) => pnl.visible).map((pnl) => pnl.name);
    localStorage.setItem(favouriteSymbolsLocalStorageKey, JSON.stringify(visibleSymbols));
    message.success(`Saved ${visibleSymbols.join(", ")} as favourite symbols!`);
  };

  // View the favourite symbols by updating visibility based on stored favourites
  const viewFavouriteSymbols = () => {
    const storedFavourites = localStorage.getItem(favouriteSymbolsLocalStorageKey);
    if (storedFavourites) {
      const favouriteSymbols = JSON.parse(storedFavourites);
      updateSymbolVisibility(favouriteSymbols);
    } else {
      message.error("No favourite symbols saved.");
    }
  };

  return (
    <Space>
      <Button onClick={saveFavouriteSymbols}>Save as Favourite</Button>
      <Button onClick={viewFavouriteSymbols}>Show Favourite Symbols</Button>
    </Space>
  );
};

export default FavouriteSymbols;
